import React from 'react';
import {injectIntl} from 'react-intl';
import {percentualize} from '../../../services/dashboardUtils';
import {fillChartOptions} from '../../../utils/analytics';
import FullscreenChart from './FullscreenChart';
import Highcharts from 'highcharts';
const buildColumnChartOptions = (config, data, hints, intl) => {
    const sum = data.series.map((s) => s.values.reduce((a, b) => a + b, 0));
    const colors = data.categories.map((c, i) => (data.exclusiveIndex !== i ? Highcharts.theme.colors[0]: '#B6B6B5'));
    return fillChartOptions({
        chart: {
            type: 'column',
        },
        legend: {enabled: false},
        xAxis: {
            categories: data.categories,
            title: {enabled: false, text: config.title},
        },
        yAxis: {
            title: {enabled: false},
            allowDecimals: false,
        },
        series: data.series.map((s, i) => ({
            data: s.values.map((value) => percentualize(value, sum[i], hints)),
            name: s.name,
            dataLabels: {
                enabled: true,
                format: hints.absolute ? '{point.y}' : '{point.y:.1f}%',
            },
        })),
        tooltip: {
            formatter: function() {
                return hints.absolute ? `${this.y}` : `${this.y}%`;
            },
        },
        plotOptions: {
            series: {
                colorByPoint: true,
                colors: colors,
            },
        },
    }, config, data, hints, intl);
};

const buildAverageBarChartOptions = (config, data, hints, intl) => {
    const leftCategories = data.series.map((s) => s.leftLabel);
    const rightCategories = data.series.map((s) => s.rightLabel);
    const origin = (data.min + data.max) / 2;

    return fillChartOptions({
        chart: {
            type: 'bar',
        },
        legend: {enabled: false},
        xAxis: [
            {
                categories: leftCategories,
                labels: {
                    step: 1,
                },
            },
            {
                opposite: true,
                categories: rightCategories,
                labels: {
                    step: 1,
                },
                linkedTo: 0,
            },
        ],
        yAxis: {
            title: {enabled: false},
            min: data.min,
            max: data.max,
            allowDecimals: false,
            plotLines: [{
                width: 1,
                value: origin,
                color: '#AAAAAA', // TODO
                zIndex: 9,
            }],
        },
        plotOptions: {
            series: {
                threshold: origin,
                negativeColor: '#E8617F', // TODO
            },
            bar: {
                minPointLength: 2,
            },
        },
        series: [{
            name: '',
            data: data.series.map((s) => ({y: s.value, name: `${s.leftLabel} - ${s.rightLabel}`})),
            dataLabels: {
                enabled: true,
                format: '{point.y}' /* hints.absolute ? '{point.y}' : '{point.y:.1f}%'*/,
            },
        }],
        tooltip: {
            formatter: function() {
                return hints.absolute ? `${this.y}` : `${this.y}%`;
            },
        },
    }, config, data, hints, intl);
};

const builders = {
    column: buildColumnChartOptions,
    averageBar: buildAverageBarChartOptions,
};

const buildOptions = (config, data, hints, intl) => {
    if (builders[config.chart]) {
        return builders[config.chart](config, data, hints, intl);
    }
    return builders.column(config, data, hints, intl);
};

const NumberWidget = ({intl, data, params, hints}) => (
    <FullscreenChart hints={hints} options={buildOptions(params, data, hints, intl)} customLabel={`n=${data.count}`} />
);

export default injectIntl(NumberWidget);
